const Content = {
  'expertise': {
    'title': 'We’re in 30+ markets, including…',
    'stat1_top': 'We\'ve conducted',
    'stat1_bottom': 'interviews over the past decade.',
    'stat2_top': 'We\'ve listened to',
    'stat2_bottom': 'digital conversations so far this year.',
    'flags': [
      {
        'asset': 'usa',
        'name': 'America'
      },
      {
        'asset': 'ca',
        'name': 'Canada'
      },
      {
        'asset': 'uk',
        'name': 'United Kingdom'
      },
      {
        'asset': 'mx',
        'name': 'Mexico'
      },
      {
        'asset': 'ru',
        'name': 'Russia'
      },
      {
        'asset': 'it',
        'name': 'Italy'
      },
      {
        'asset': 'es',
        'name': 'Spain'
      },
      {
        'asset': 'jp',
        'name': 'Japan'
      },
      {
        'asset': 'cn',
        'name': 'China'
      },
      {
        'asset': 'fr',
        'name': 'France'
      },
      {
        'asset': 'de',
        'name': 'Germany'
      },
      {
        'asset': 'br',
        'name': 'Brazil'
      },
      {
        'asset': 'kr',
        'name': 'South Korea'
      },
      {
        'asset': 'au',
        'name': 'Austrailia'
      }
    ]
  }
};

export { Content };
